module.exports = __webpack_public_path__ + "static/media/Athelas-Regular.c35d02bb.svg";